import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PropaneTankIcon(props: IconProps) {
    return <Icon {...props} iconKey={"propane_tank"}/>
}
